import Container from "../Container";
import LogoBrand from "../Icons/_Logo/TDCX/LogoBrand";
import Earth from "../Icons/_Elements/Earth";
import Button from "../Button";
import React, { useContext } from "react";
import { ChatbotState } from "../Layout";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  header: {
    padding: "21px 0"
  },
  headerInner: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  logo: {
    "& svg": {
      width: 82,
      height: 33,
      display: "block"
    }
  },
  visitWebsite: {
    marginLeft: "auto",
    fontSize: ".875rem",
    padding: theme.spacing(1.25, 1.5),
    backgroundColor: "#F2F2F2",
    color: "#333333",
    fontWeight: 700,
    lineHeight: 1,
    marginTop: 0,
    marginBottom: 0
  },
  visitWebsiteIcon: {
    "& svg": {
      width: "2.25rem !important",
      height: "2.25rem !important",
      margin: "-5px 2px -5px -5px"
    }
  }
}));

function Header() {
  const { setChatbotOpen } = useContext(ChatbotState);

  const classes = useStyles();
  return (
    <div className={classes.header}>
      <Container className={classes.headerInner}>
        <div className={classes.logo}>
          <LogoBrand />
        </div>
        <Button
          type="submit"
          className={classes.visitWebsite}
          onClick={() => setChatbotOpen(false)}
        >
          <span className={classes.visitWebsiteIcon}>
            <Earth />
          </span>{" "}
          Visit website
        </Button>
      </Container>
    </div>
  );
}

export default Header;
